<div class="session-shell" *ngIf="!isLoadingSession; else sessionLoading">
  <aside class="session-shell__sidebar">
    <div class="session-shell__brand">
      <p class="session-shell__brand-name">Queueify</p>
    </div>

    <nav class="session-shell__nav" aria-label="Session navigation">
      <button
        *ngFor="let navItem of visibleNavItems"
        class="session-shell__nav-item"
        type="button"
        [class.session-shell__nav-item--active]="isActiveNavItem(navItem)"
        (click)="onSelectNavItem(navItem)"
      >
        <span class="material-symbols-outlined">{{ navItem.icon }}</span>
        <span>{{ navItem.label }}</span>
      </button>
    </nav>
  </aside>

  <div class="session-shell__canvas">
    <header class="session-shell__topbar">
      <div class="session-shell__topbar-left">
        <p class="session-shell__topbar-brand">Queueify</p>
        <span class="session-shell__chip">Live Session</span>
      </div>
    </header>

    <div class="session-shell__content">
      <router-outlet></router-outlet>
    </div>

    <div
      class="session-shell__now-playing"
      *ngIf="currentTrack"
      [class.session-shell__now-playing--readonly]="!sessionState.isOwner"
    >
      <img
        class="session-shell__now-playing-art"
        [src]="currentTrack.album?.images?.[0]?.url"
        [alt]="currentTrack.name || 'Currently playing artwork'"
      />
      <div class="session-shell__now-playing-copy">
        <p class="session-shell__now-playing-title">{{ currentTrack.name }}</p>
        <p class="session-shell__now-playing-subtitle">
          {{ currentTrackArtistLine }}
        </p>
      </div>
      <div
        class="session-shell__now-playing-controls"
        *ngIf="sessionState.isOwner"
      >
        <button
          class="session-shell__now-playing-control"
          type="button"
          [disabled]="!canControlPlayback || playbackControlPending !== null"
          aria-label="Previous track"
          (click)="onSkipPrevious()"
        >
          <span class="material-symbols-outlined">skip_previous</span>
        </button>
        <button
          class="session-shell__now-playing-play"
          type="button"
          [disabled]="!canControlPlayback || playbackControlPending !== null"
          [attr.aria-label]="isPlaying ? 'Pause playback' : 'Resume playback'"
          (click)="onTogglePlayback()"
        >
          <span class="material-symbols-outlined">
            {{ isPlaying ? 'pause' : 'play_arrow' }}
          </span>
        </button>
        <button
          class="session-shell__now-playing-control"
          type="button"
          [disabled]="!canControlPlayback || playbackControlPending !== null"
          aria-label="Next track"
          (click)="onSkipNext()"
        >
          <span class="material-symbols-outlined">skip_next</span>
        </button>
      </div>
      <div class="session-shell__now-playing-meter">
        <div class="session-shell__now-playing-times">
          <span>{{ playbackProgress.elapsedLabel }}</span>
          <span>{{ playbackProgress.durationLabel }}</span>
        </div>
        <div class="session-shell__now-playing-progress">
          <span [style.width.%]="playbackProgress.progressPercent"></span>
        </div>
      </div>
    </div>

    <nav class="session-shell__bottom-nav" aria-label="Session navigation">
      <button
        *ngFor="let navItem of visibleNavItems"
        class="session-shell__bottom-nav-item"
        type="button"
        [class.session-shell__bottom-nav-item--active]="isActiveNavItem(navItem)"
        (click)="onSelectNavItem(navItem)"
      >
        <span class="material-symbols-outlined">{{ navItem.icon }}</span>
        <span>{{ navItem.label }}</span>
      </button>
    </nav>
  </div>
</div>

<ng-template #sessionLoading>
  <div class="session-shell__loading">
    <div class="session-shell__loading-card">
      <p class="session-shell__loading-label">Loading Session</p>
      <h1>Preparing your listening room.</h1>
    </div>
  </div>
</ng-template>
